export class BuyDownsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getBuyDowns(params) {
    return this.#http.get('/api/buy-downs', { params });
  }

  async createBuyDown(body) {
    return this.#http.post('/api/buy-downs', body);
  }

  async editBuyDown({ id, ...body }) {
    return this.#http.put(`/api/buy-downs/${id}`, body);
  }

  async deleteBuyDown({ id }) {
    return this.#http.delete(`/api/buy-downs/${id}`);
  }
}
